import Cookies from 'vue-cookies'
import {Base64} from "js-base64";

const TokenKey = 'invoice_accout_token'
const InfoKey  = 'invoice_accout_info';

/**
 * 获取 token
 * @returns 
 */
export function getToken() {
  return Cookies.get(TokenKey);
}

/**
 * 获取用户信息
 * @returns 
 */
export function getInfo() {
  let info = Cookies.get(InfoKey);
  if(info == null){
     return null;
  }
  let json = Base64.decode(info);
  return JSON.parse(json);
}


/**
 * 设置token
 * @param {*} token 
 * @returns 
 */
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

/**
 * 移除Token
 * @returns 
 */
export function removeToken() {
  return Cookies.remove(TokenKey)
}

/**
 * 移除缓存
 * @returns 
 */
export function removeTokenAndInfo() {
   Cookies.remove(TokenKey);
   Cookies.remove(InfoKey);
   return true;
}


/**
 * 存储信息
 * @param {*} data 
 */
export function storeAccount(data) {
  let token = data.token;
  let json  = JSON.stringify(data);
  let b64 = Base64.encode(json);
  Cookies.set(TokenKey, token);
  Cookies.set(InfoKey,b64);
}

/**
 * 存储信息
 * @param {*} data 
 */
export function storeAccountInfo(email,unitName,unitTaxCode) {
  let info = getInfo();
  if(info == null){
     return;
  }
  info.email = email;
  info.unitName = unitName;
  info.unitTaxCode = unitTaxCode;
  storeAccount(info);
}


// WEBPACK FOOTER //
// ./src/cookie.js